import React from 'react';

import { Modal } from 'src/components/common';
import { EmployerControlledByConfigurationModalForm } from 'src/components/employer/EmployerControlledByConfigurationModalForm';
import { useModalV2 } from 'src/hooks/shared';
import { ModalV2Props } from 'src/types/modalV2';

type EmployerControlledByConfigurationModalProps = {
  employerId: string;
};

export const EmployerControlledByConfigurationModal: React.FC<
  ModalV2Props<EmployerControlledByConfigurationModalProps>
> = ({ id, employerId }) => {
  const { closeModal, switchClosability } = useModalV2();

  const handleCloseModal = React.useCallback(() => {
    closeModal(id);
  }, [closeModal, id]);

  return (
    <Modal
      title="Manage employer hierarchy"
      maxWidth={550}
      headerPadding="32px 32px 8px 32px"
      dialogProps={{
        onClose: handleCloseModal,
        open: true,
      }}
    >
      <EmployerControlledByConfigurationModalForm
        employerId={employerId}
        onCloseModal={handleCloseModal}
        switchClosability={switchClosability}
      />
    </Modal>
  );
};
